<div>
  <div class="modal_header">
    <i class="fa fa-file-pdf header-icon"></i>
    <p>DOWNLOAD PDF</p>
    <div class="modal__close" (click)="closeModal();">
    </div>
  </div>
  <div class="modal__download">
    <div class="doc-name-input-container mb-3">
      <label class="control-label" for="downloadDocInput">File Name:</label>
      <div class="input-group has-feedback">
        <input id="downloadDocInput" type="text" [formControl]="downloadFileName" class="form-control"
          maxlength="100" [ngClass]="{'is-invalid': downloadFileName.invalid}">
        <span class="input-group-text">.pdf</span>
        @if (downloadFileName.invalid && downloadFileName.hasError('required')) {
          <span class="invalid-feedback">
            Download File Name is required
          </span>
        }
      </div>
    </div>
  </div>
  <div class="modal__content">
    @if (showSpinner) {
      <div class="loader__container">
        <div class="loader loader-for-modal-content"></div>
      </div>
    } @else {
      <div class="column-headers">
        <div class="panel-header">
          <h4 class="column-title mt-2">
            Available Documents
          </h4>
          <p class="column-sub-title">Select documents to add it to the download list.</p>
        </div>
        <div class="panel-header">
          <h4 class="column-title mt-2">Download List</h4>
          <p class="column-sub-title">Drag and drop to reorder this list.</p>
        </div>
      </div>
      <div class="column-content">
        <div class="entity-list-container panel-container">
          @for (entity of entitiesWithDownloadableDocs; track entity) {
            <div>
              <div>
                <p class="entity-name">{{entity.entityName}}</p>
                @if (entity?.financialDataViews?.length) {
                  <div class="entity-container">
                    <p class="doc-category-title">Financials</p>
                    <div class="doc-list">
                      @for (dataView of entity.financialDataViews; track dataView) {
                        <div
                                        [ngClass]="{
                                    'doc-item': true,
                                    'selected': dataView?.selected
                                }"
                          (click)="selectDoc(dataView)"
                          >
                          {{dataView.name}}
                        </div>
                      }
                    </div>
                  </div>
                }
                @if (entity?.analyses?.length) {
                  <div class="entity-container">
                    <p class="doc-category-title">Analyses</p>
                    @for (analysis of entity.analyses; track analysis) {
                      <div
                                    [ngClass]="{
                                    'doc-item': true,
                                    'selected': analysis?.selected
                                }"
                        (click)="selectDoc(analysis)"
                        >
                        {{analysis.name}}
                      </div>
                    }
                  </div>
                }
                @if (entity?.globalCashflows?.length) {
                  <div class="entity-container">
                    <p class="doc-category-title">Global Cashflow</p>
                    @for (globalCashflow of entity.globalCashflows; track globalCashflow) {
                      <div
                                    [ngClass]="{
                                    'doc-item': true,
                                    'selected': globalCashflow?.selected
                                }"
                        (click)="selectDoc(globalCashflow)"
                        >
                        {{globalCashflow.name}}
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          }
        </div>
        <div class="download-list-container panel-container">
          @if (documentsToBeDownloaded && documentsToBeDownloaded?.length) {
            <div cdkDropList
              class="drag-drop-list"
              (cdkDropListDropped)="drop($event)">
              @for (doc of documentsToBeDownloaded; track doc) {
                <div class="drag-drop-box" cdkDrag>
                  <span class="document-name">{{doc.name}}</span>
                  <span (click)="_removeDocumentToDownloadList(doc)"><i
                  class="far fa-times-circle remove-icon"></i></span>
                </div>
              }
            </div>
          }
        </div>
      </div>
      <div class = "modal__footer">
        <div class="footer-action-container">
          <button type="reset" class="btn btn-empty-primary upload-footer"
          (click)="closeModal();">{{fileDownloadProcessBegun ? 'Close' : 'Cancel'}}</button>
          <button type="submit" class="btn btn-primary upload-footer"
            [disabled]="downloadFileName.invalid || !documentsToBeDownloaded?.length || fileDownloadProcessBegun"
            (click)="download()">Download
            @if (fileDownloadProcessBegun) {
              <div class="loader button-loader"></div>
            }
          </button>
        </div>
      </div>
    }
  </div>
</div>
